import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "as-performance__head" }
const _hoisted_2 = { class: "as-performance__body" }
const _hoisted_3 = { class: "as-vs" }
const _hoisted_4 = { class: "as-vs__line" }
const _hoisted_5 = { class: "as-vs-line-item" }
const _hoisted_6 = { class: "as-vs-line-item__ball" }
const _hoisted_7 = { class: "as-icon" }
const _hoisted_8 = {
  key: 0,
  class: "as-vs__text"
}
const _hoisted_9 = { class: "as-bold" }
const _hoisted_10 = { class: "as-green" }
const _hoisted_11 = { class: "as-bold" }
const _hoisted_12 = { class: "as-competition" }
const _hoisted_13 = { class: "as-competition__table" }
const _hoisted_14 = { class: "as-center a" }
const _hoisted_15 = { class: "as-center a" }

import type { IMatch } from "~src/interfaces";
import FootballTeamItem from "~src/components/foot_stats/FootballTeamItem.vue";
import IconPerformanceHalfTime from "~src/components/icons/foot_stats/IconPerformanceHalfTime.vue";
import IBall from "~src/components/icons/incident/IBall.vue";
import type {
  IFootyStats,
  ITeam,
  IStatsParent,
} from "~src/interfaces/footystats";
import { computed } from "vue";
import { getClassForItem, getPercentByPoint } from "~src/helpers/footystats";


const __default__ = {};

interface Props {
  match: IMatch;
  modifyClass?: string;
  footyStats: IFootyStats | null;
  homeTeamInfo: ITeam | null;
  awayTeamInfo: ITeam | null;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'PerformanceHalfTime',
  props: {
    match: {},
    modifyClass: { default: "" },
    footyStats: {},
    homeTeamInfo: {},
    awayTeamInfo: {}
  },
  setup(__props: any) {

const props = __props;

const homeTeamLastX = computed<IStatsParent>(() => {
  return props.footyStats?.home_team_last_x ?? ({} as IStatsParent);
});

const awayTeamLastX = computed<IStatsParent>(() => {
  return props.footyStats?.away_team_last_x ?? ({} as IStatsParent);
});

const homePoint = computed<number>(() => {
  return homeTeamLastX.value?.stats?.HTPPG_overall ?? 0;
});

const awayPoint = computed<number>(() => {
  return awayTeamLastX.value?.stats?.HTPPG_overall ?? 0;
});

const getValueWithMode = (team = "home", mode = "btts", half = 1) => {
  const __data: IStatsParent =
    team === "home" ? homeTeamLastX.value : awayTeamLastX.value;
  if (
    !__data ||
    !__data.stats ||
    !__data.stats.hasOwnProperty(mode)
  ) {
    return 0;
  }

  return __data.stats[mode] as number;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`as-performance ${_ctx.modifyClass} as-half-time`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(IconPerformanceHalfTime),
      _cache[0] || (_cache[0] = _createElementVNode("span", null, " Phong độ hiệp 1/2 ", -1))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(FootballTeamItem, {
        footyStats: _ctx.footyStats,
        match: _ctx.match,
        modifyClass: "as-vertical",
        showName: false,
        showResult: false,
        showState: true,
        homePoint: homePoint.value,
        awayPoint: awayPoint.value
      }, null, 8, ["footyStats", "match", "homePoint", "awayPoint"]),
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "as-vs__tile" }, "HT - Overall", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "as-vs-line-item__main" }, null, -1)),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "as-vs-line-item__percent" }, null, -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(IBall)
              ])
            ])
          ])
        ]),
        (homePoint.value > 0 || awayPoint.value > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(homePoint.value > awayPoint.value ? _ctx.footyStats?.home_name : _ctx.footyStats?.away_name), 1),
              _cache[3] || (_cache[3] = _createTextVNode(" có ")),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(getPercentByPoint)(homePoint.value, awayPoint.value)) + "%", 1),
              _cache[4] || (_cache[4] = _createTextVNode(" phong độ tốt hơn")),
              _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("span", _hoisted_11, _toDisplayString(homePoint.value > awayPoint.value ? _ctx.footyStats?.away_name : _ctx.footyStats?.home_name), 1),
              _cache[6] || (_cache[6] = _createTextVNode(" trong hiệp 1 "))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(FootballTeamItem, {
        footyStats: _ctx.footyStats,
        match: _ctx.match,
        modeTeam: "as-away",
        modifyClass: "as-vertical",
        showName: false,
        showResult: false,
        showState: true,
        homePoint: homePoint.value,
        awayPoint: awayPoint.value
      }, null, 8, ["footyStats", "match", "homePoint", "awayPoint"])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("table", _hoisted_13, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _cache[8] || (_cache[8] = _createElementVNode("th", null, "Phong độ H1/H2", -1)),
            _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.footyStats?.home_name), 1),
            _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.footyStats?.away_name), 1)
          ])
        ]),
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _cache[9] || (_cache[9] = _createElementVNode("td", null, "Thắng % Hiệp 1", -1)),
            _createElementVNode("td", {
              class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                getValueWithMode('home', 'firstGoalScoredPercentage_away')
              )}`)
            }, _toDisplayString(getValueWithMode("home", "firstGoalScoredPercentage_away")) + "% ", 3),
            _createElementVNode("td", {
              class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                getValueWithMode('away', 'firstGoalScoredPercentage_away')
              )}`)
            }, _toDisplayString(getValueWithMode("away", "firstGoalScoredPercentage_away")) + "% ", 3)
          ]),
          _createElementVNode("tr", null, [
            _cache[10] || (_cache[10] = _createElementVNode("td", null, "Thắng % Hiệp 2", -1)),
            _createElementVNode("td", {
              class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                getValueWithMode('home', 'wins_2hg_percentage_overall')
              )}`)
            }, _toDisplayString(getValueWithMode("home", "wins_2hg_percentage_overall")) + "% ", 3),
            _createElementVNode("td", {
              class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                getValueWithMode('away', 'wins_2hg_percentage_overall')
              )}`)
            }, _toDisplayString(getValueWithMode("away", "wins_2hg_percentage_overall")) + "% ", 3)
          ]),
          _createElementVNode("tr", null, [
            _cache[11] || (_cache[11] = _createElementVNode("td", null, "Hòa % Hiệp 1", -1)),
            _createElementVNode("td", {
              class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                getValueWithMode('home', 'drawingAtHTPercentage_overall')
              )}`)
            }, _toDisplayString(getValueWithMode("home", "drawingAtHTPercentage_overall")) + "% ", 3),
            _createElementVNode("td", {
              class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                getValueWithMode('away', 'drawingAtHTPercentage_overall')
              )}`)
            }, _toDisplayString(getValueWithMode("away", "drawingAtHTPercentage_overall")) + "% ", 3)
          ]),
          _createElementVNode("tr", null, [
            _cache[12] || (_cache[12] = _createElementVNode("td", null, "Hòa % Hiệp 2", -1)),
            _createElementVNode("td", {
              class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                getValueWithMode('home', 'draws_2hg_percentage_overall')
              )}`)
            }, _toDisplayString(getValueWithMode("home", "draws_2hg_percentage_overall")) + "% ", 3),
            _createElementVNode("td", {
              class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                getValueWithMode('away', 'draws_2hg_percentage_overall')
              )}`)
            }, _toDisplayString(getValueWithMode("away", "draws_2hg_percentage_overall")) + "% ", 3)
          ]),
          _createElementVNode("tr", null, [
            _cache[13] || (_cache[13] = _createElementVNode("td", null, "Thua % Hiệp 1", -1)),
            _createElementVNode("td", {
              class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                getValueWithMode('home', 'trailingAtHTPercentage_overall')
              )}`)
            }, _toDisplayString(getValueWithMode("home", "trailingAtHTPercentage_overall")) + "% ", 3),
            _createElementVNode("td", {
              class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                getValueWithMode('away', 'trailingAtHTPercentage_overall')
              )}`)
            }, _toDisplayString(getValueWithMode("away", "trailingAtHTPercentage_overall")) + "% ", 3)
          ]),
          _createElementVNode("tr", null, [
            _cache[14] || (_cache[14] = _createElementVNode("td", null, "Thua % Hiệp 2", -1)),
            _createElementVNode("td", {
              class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                getValueWithMode('home', 'losses_2hg_percentage_overall')
              )}`)
            }, _toDisplayString(getValueWithMode("home", "losses_2hg_percentage_overall")) + "% ", 3),
            _createElementVNode("td", {
              class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                getValueWithMode('away', 'losses_2hg_percentage_overall')
              )}`)
            }, _toDisplayString(getValueWithMode("away", "losses_2hg_percentage_overall")) + "% ", 3)
          ])
        ])
      ])
    ])
  ], 2))
}
}

})